import { render, staticRenderFns } from "./MakeForm.vue?vue&type=template&id=feebc0b8&"
import script from "./MakeForm.vue?vue&type=script&lang=js&"
export * from "./MakeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports